<template>
    <div class="px-3">
        <div class="loader" v-if="loading"></div>
        <div v-if="!isNewEvent && showRelatedForms">
            <div
                v-if="showHelp"
            >
                <p>
                    <button class="btn btn-info btn-link" type="button" data-toggle="collapse" data-target="#collapseHelp" aria-expanded="false" aria-controls="collapseHelp">
                        {{ $t('help.menuTitle') }}
                    </button>
                </p>
                <div class="collapse" id="collapseHelp">
                    <div class="card card-body mb-2">
                        <ul>
                            <li>{{ $t('buttons.add.btnText') }} - !isLockedForEdit && eventClaims[EventClaims.EventFormManagement].create</li>
                            <li>{{ $t('buttons.timeRangeEdit.btnText') }} - formToRegisterEntityId && eventClaims[EventClaims.EventFormManagement].create</li>
                            <li>
                                {{ $t('buttons.formEdit.btnText') }} - claims.formSurvey.update
                            </li>
                            <li>
                                {{ $t('buttons.formDetails.btnText') }} - claims.formSurvey.read || (eventClaims && eventClaims[EventClaims.EventFormManagement].read
                            </li>
                            <li>
                                {{ $t('buttons.dataReview.btnText') }} - claims.formSurvey.read || (eventClaims && eventClaims[EventClaims.EventFormManagement].read
                            </li>
                            <li>
                                {{ $t('buttons.summaryDataReview.btnText') }} - claims.formSurvey.read || (eventClaims && eventClaims[EventClaims.EventFormManagement].read
                            </li>
                            <li>
                                {{ $t('buttons.summaryDataReport.btnText') }} - claims.formSurvey.read || (eventClaims && eventClaims[EventClaims.EventFormManagement].read
                            </li>
                            <li>
                                {{ $t('buttons.delete.btnText') }} - claims.formSurvey.delete || (eventClaims && eventClaims[EventClaims.EventFormManagement].delete)
                            </li>
                            <li>
                                {{ $t('buttons.deleteWithForm.btnText') }} - claims.formSurvey.delete || (eventClaims && eventClaims[EventClaims.EventFormManagement].delete)
                            </li>
                            <li>
                                {{ $t('buttons.deleteFormWithRelatedRecords.btnText') }} - userRoles.includes(Role.SuperAdmin)
                            </li>
                            <li>
                                {{ $t('buttons.formCompleteActivate.btnText') }} - claims.formSurvey.update || (eventClaims && eventClaims[EventClaims.EventFormManagement].update)
                            </li>
                            <li>
                                {{ $t('buttons.formCompleteDeactivate.btnText') }} - claims.formSurvey.update || (eventClaims && eventClaims[EventClaims.EventFormManagement].update)
                            </li>
                            <li>
                                {{ $t('buttons.copy.btnText') }} - claims.formSurvey.create
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <forms-grid ref="relatedForms"
                        :relatedEventId="Number(eventId)"
                        :showHideButton="false"
                        :showPinButton="false"
                        :showNewButton="true"
                        :showResizeIcon="false"
                        :showSettingsBtn="showBtnSettings"
                        :showBtns="!isLockedForEdit"
                        :showAddButton="!isLockedForEdit"
                        :componentName="'FormsManagementListGrid'"
                        :showDashboardCtrls="false"
                        :showInCard="false">
            </forms-grid>

            <div class="mt-5" v-if="hasEventId">
                <forms-summary ref="formSummary"
                               :relatedEventId="Number(eventId)"
                               @formCreate="onFormCreate"
                               @formEdit="onFormEdit">
                </forms-summary>
            </div>
        </div>

    </div>
</template>

<script>
    import { FormToEvent } from '@/models/models';
    import FormsGrid from '@/components/forms/FormsGrid';
    import FormsSummary from "@/components/forms/FormsSummary";
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            eventId: {
                type: Number,
                required: true
            },
            details: {
                type: Boolean,
                default: false
            },
            showRelatedForms: {
                default: false,
                type: Boolean
            },
            canWrite: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            showBtnSettings: {
                type: Boolean,
                default: true
            }
        },
        components: {
            FormsGrid,
            FormsSummary
        },
        data() {
            return {
                loading: false,
                formToEventItems: [],
                searchQueryFormsToEvent: '',
                saving: false,
                formsToEventgridCaptions: {
                    checked: '',
                    name: 'registers.forms.formToEvent.gridHeaders.name',
                    nameEn: 'registers.forms.formToEvent.gridHeaders.nameEn',
                    formType: 'registers.forms.formToEvent.gridHeaders.formType',
                    formTypeEn:
                        'registers.forms.formToEvent.gridHeaders.formTypeEn',
                    note: 'registers.forms.formToEvent.gridHeaders.note',
                    link: 'registers.forms.formToEvent.gridHeaders.comletionLink',
                    validFromUtc:
                        'registers.forms.formToEvent.gridHeaders.validFromUtc',
                    validToUtc: 'registers.forms.formToEvent.gridHeaders.validToUtc'
                },
                formsToEventgridColumns: [
                    'checked',
                    'name',
                    'formType',
                    'note',
                    'link',
                    'validFromUtc',
                    'validToUtc'
                ],
                formsToEventBtns: [
                    {
                        name: 'edit',
                        text: '',
                        tooltip: this.$t('buttons.edit.btnText'),
                        class: 'btn btn-primary',
                        icon: 'fas fa-edit',
                        show: true,
                        clickHandler: this.editBtnClick
                    },
                    {
                        name: 'copy',
                        text: '',
                        tooltip: this.$t('buttons.copy.btnText'),
                        class: 'btn btn-primary',
                        icon: 'fas fa-copy',
                        show: true,
                        clickHandler: this.copyBtnClick
                    }
                ]
            };
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get('/api/dynamicForms/formsToEvent', {
                        params: {
                            eventId: this.eventId
                        }
                    })
                    .then(response => {
                        this.loading = false;

                        if (
                            Array.isArray(response.data.items) &&
                            response.data.items.length > 0
                        ) {
                            response.data.items.forEach((item, index) => {
                                this.formToEventItems.push(new FormToEvent(item));
                            });
                            this.$refs.relatedForms.refresh();
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            saveFormToEvent() {
                kendo
                    .confirm(`${this.$t('registers.forms.confirmations.save')}`)
                    .then(
                        function () {
                            this.saving = true;
                            var model = {
                                eventId: this.eventId,
                                relatedForms: this.formToEventItems.filter(
                                    form => form.checked
                                )
                            };

                            this.$http
                                .post('/api/DynamicRegisters/addForms', model)
                                .then(response => {
                                    this.saving = false;
                                    this.$vs.notify({
                                        title: this.$t('buttons.save.btnText'),
                                        text: this.$helpers.responseMessage(
                                            response
                                        ),
                                        color: 'success',
                                        time: this.$store.getters
                                            .notificationDuration
                                    });

                                    this.$refs.relatedForms.refresh();
                                })
                                .catch(error => {
                                    this.saving = false;

                                    this.$vs.notify({
                                        title: this.$t(
                                            'request.response.status.' +
                                            this.$helpers.errorStatusCode(error)
                                        ),
                                        text: this.$helpers.errorText(error),
                                        color: this.$helpers.errorColor(error),
                                        time: this.$store.getters
                                            .notificationDuration
                                    });
                                });
                        }.bind(this)
                    );
            },
            editBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'editForm', query: { id: args.id, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            copyBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'copyForm', query: { id: args.id, eventId: this.eventId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            onFormCreate(model) {
                this.refresFormsSummary();
            },
            onFormEdit(model) {
                this.refresFormsSummary();
            },
            refresFormsSummary() {
                const formsSummaryGrid = this.$refs.formSummary;
                if (formsSummaryGrid) {
                    formsSummaryGrid.refresh();
                }
            }
        },
        mounted() {
            this.load();
        },
        computed: {
            ...mapGetters(['showHelp']),
            isNewEvent() {
                return (
                    isNaN(this.eventId) ||
                    this.eventId === undefined ||
                    this.eventId === 0
                );
            },
            hasEventId() {
                const num = Number(this.eventId);
                return !isNaN(num) && num > 0;
            }
        }
    };
</script>
